import React, { Component } from 'react';
import './App.css';
import LoginSignupShell from './Components/LoginSignup/LoginSignupShell';
import LedgerShell from './Components/Ledger/LedgerShell';

class App extends Component {
  constructor() {
    super();
    let lsSession = localStorage.getItem('session');
    console.log("cached session: ", lsSession);
    this.state = lsSession ? JSON.parse(lsSession) : {
      token: '',
      id: -1
    };

    this.setSession = this.setSession.bind(this);
    this.destroySession = this.destroySession.bind(this);
    this.fetchOptions = this.fetchOptions.bind(this);
  }

  fetchOptions() {
    return {
      method: "POST",
      // body: JSON.stringify(),
      headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.state.token
      }
    };
  }

  // Sets token and id
  setSession(session) {
    console.log("Setting session: ", session);
    localStorage.setItem('session', JSON.stringify(session));
    this.setState({ token: session.token, id: session.id });
  }

  // Destroys token and id
  destroySession() {
    let session = { token: '', id: -1 };
    localStorage.setItem('session', JSON.stringify(session));
    this.setState(session);
  }

  render() {
    return (
      <div className="App">
        {(this.state.id <= -1)
            ? <LoginSignupShell setSession={this.setSession} />
            : <LedgerShell
              destroySession={this.destroySession}
              fetchOptions={this.fetchOptions}
              user={this.state} />}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js